import { Divider } from '@eatclubapp/ec-component-library';
import { useTheme } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReactComponent as IconCircleCheck } from '../../assets/icons/error.svg';
import { Spacer } from '../../components/Spacer';
import { Typography } from '../../components/Typography';
import { restaurantPropTypes } from '../../data/models/Restaurant';
import { PageLayout } from '../../layouts/PageLayout';
import { WidgetLayout } from '../../layouts/WidgetLayout';
import { useIsMobile } from '../../utils/hooks';

const MaintenanceDisplay = ({ restaurant }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <PageLayout>
      <WidgetLayout>
        <Spacer direction='vertical' gap={isMobile ? 'm' : 'l'} centered>
          <Spacer direction='vertical' gap='m' centered>
            <IconCircleCheck
              height='60'
              width='60'
              color={
                (restaurant.data.premium && theme.colors.mainTextColour) || theme.colors.deepTeal
              }
            />
            <Typography variant='h2' centered style={{ marginBottom: '20px' }}>
              Important System Maintenance
            </Typography>
            <Divider color={theme.colors.dividerColor} />
            <Typography>
              We are currently performing essential system maintenance and updates. During this
              time, we are unable to accept any bookings.
            </Typography>
            <Typography>
              For assistance, please contact us at <strong>{restaurant?.data?.phone}</strong> during
              our regular opening hours, or try refreshing the page later.
            </Typography>
          </Spacer>
        </Spacer>
      </WidgetLayout>
    </PageLayout>
  );
};

MaintenanceDisplay.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant: state.restaurant,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceDisplay);
